// v49.52 — Single source of truth for the build version string.
// Surfaced in the sidebar footer for diagnostic feedback and included
// in every client_errors row so we can correlate bug reports to the
// exact release that produced them.

export const APP_VERSION = "v50.435";
